import { Injectable } from '@angular/core';
import * as _ from 'lodash';
import { AuthenticationService } from 'app/services/authentication.service';
import moment from 'moment-timezone';
import { CurrencyPipe } from '@angular/common';
import { TimeLineService } from 'app/services/time-line.service';
import { TranslateService } from '@ngx-translate/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { AbstractControl, FormArray, FormGroup, ValidationErrors, ValidatorFn } from '@angular/forms';
import { BaseService } from './base/base.service';
import { AppProviders } from 'app/_helpers/app.provider';
import { Observable, of } from 'rxjs';
import { map } from 'rxjs/operators';
@Injectable()

export class GlobalFuntions {

    user: any;
    agency: any;

    constructor(
        private _authenticationService: AuthenticationService,
        private _timeLineService: TimeLineService,
        private _currencyPipe: CurrencyPipe,
        private _translateService: TranslateService,
        private _snackBar: MatSnackBar,
        private _baseService: BaseService,
        private _app: AppProviders
    ) {
        this._authenticationService.currentUser
            .subscribe(() => this.user = this._authenticationService.currentUserValue);
        this._authenticationService.currentAgency
            .subscribe(() => this.agency = this._authenticationService.currentAgencyValue);
    }

    caseAndAccentInsensitive = (() => {
        const accentMap = ((letters) => {
            const map = {};
            while (letters.length > 0) {
                const letter = '[' + letters.shift() + ']';
                const chars = letter.split('');
                while (chars.length > 0) {
                    map[chars.shift()] = letter;
                }
            }
            return map;
        })([
            'aàáâãäå', // a
            'cç', // c
            'eèéêë', // e
            'iìíîï', // i
            'nñ', // n
            'oòóôõöø', // o
            'sß', // s
            'uùúûü', // u
            'yÿ' // y
        ]);
        return (text: string) => {
            let textFold = '';

            if (!text) {
                return textFold;
            }

            text = text.toLowerCase();
            for (let idx = 0; idx < text.length; idx++) {
                const charAt = text.charAt(idx);

                textFold += accentMap[charAt] || charAt;
            }
            return '(?i)' + textFold;
        };
    })();

    // this method will remove all the null or empty values
    cleanObject(obj: any): any {
        Object
            .entries(obj)
            .forEach(([k, v]: any) => {
                if (v && typeof v === 'object') {
                    // Check if v is a Date object and skip cleaning
                    if (v instanceof Date) {
                        return; // Skip cleaning this Date object
                    }
                    this.cleanObject(v);
                }
                if (v && typeof v === 'object' && !Object.keys(v).length || v === null || v === undefined || v === '') {
                    if (Array.isArray(obj)) {
                        obj.splice(k, 1);
                    } else {
                        delete obj[k];
                    }
                }
            });
        return obj;
    }

    // Remove the null or empty values only for new entries if entry already exist in the db then it will not remove
    cleanObjectForNewEntries(obj: any, oldObj: any, newEmptyValues: Array<any> = []): any {
        Object.entries(obj)
            .forEach(([k, v]: any) => {
                const excludedKeys = ["categories", "climate_control", "conditions", "distances", "features", "furniture", "garden", "kitchen", "leisures", "living_room", "null", "orientations", "parking", "pool", "rooms", "security", "settings", "utility", "views"];
                if (v && typeof v === 'object') {
                    let oldV = [];
                    if (oldObj[k]) {
                        oldV = oldObj[k];
                    }
                    this.cleanObjectForNewEntries(v, oldV, newEmptyValues);
                }
                if (v && typeof v === 'object' && !Object.keys(v).length || v === null || v === undefined || v === '') {
                    if (
                        !(k in oldObj) ||
                        [0, null, undefined, ''].includes(oldObj[k]) ||
                        (Array.isArray(oldObj[k]) && !oldObj[k].length) ||
                        excludedKeys.indexOf(k) !== -1 // For `features`
                    ) {
                        if (Array.isArray(obj)) {
                            obj.splice(k, 1);
                        } else {
                            delete obj[k];
                        }
                    } else if (k !== 'length') {
                        newEmptyValues.push(k);
                    }
                }
            });
        return obj;
    }

    clearObject(obj: object): object {
        if (_.isArray(obj)) {
            _.remove(obj, (o) => o === '' || o === null);
            return _(obj)
                .filter(_.isObject)
                .map((o) => this.clearObject(o))
                .reject(_.isEmpty)
                .concat(_.reject(obj, _.isObject))
                .value();
        }
        obj = _.pickBy(obj, _.identity);
        return _(obj)
            .pickBy(_.isObject)
            .mapValues((o) => this.clearObject(o))
            .omitBy(_.isEmpty)
            .assign(_.omitBy(obj, _.isObject))
            .value();
    }

    /**
     * Deep diff between two object, using lodash
     * @param  {Object} object Object compared
     * @param  {Object} base   Object to compare with
     * @return {Object}        Return a new object who represent the diff
     */
    difference(object: any, base: any): any {
        return _.transform(object, (result, value, key: any) => {
            const otherValue = base?.[key];

            //Handle object & array case separately
            if (_.isObject(value) && _.isObject(otherValue) && !_.isArray(value)) {
                const diff = this.difference(value, otherValue);
                if (Object.keys(diff).length > 0) {
                    result[key] = diff;
                }
            } else if (_.isArray(value) && _.isArray(otherValue)) {
                if (!_.isEqual(value, otherValue)) {
                    result[key] = value;
                }
            } else if (!_.isEqual(value, otherValue)) {
                result[key] = value;
            }
        }, {});
    }

    disableFunction(agency: any, createdBy: any): any {
        if (this.user.user_role === 'admin' || this.user.user_role === 'agency_admin') {
            if (this.user.user_agency === agency) {
                return true;
            }
            else {
                return false;
            }
        } else if (this.user.user_role === 'agency_manager' && this.user.user_id === createdBy) {
            return true;
        } else {
            if (this.user.user_id === createdBy) {
                return true;
            }
            else {
                return false;
            }
        }
    }

    disableFuncContacts(agency: any, createdBy: any): any {
        if (this.user.user_role === 'admin') {
            return true;
        }
        else {
            if (this.user.user_role === 'agency_manager' || this.user.user_role === 'agency_admin') {
                if (this.user.user_agency === agency) {
                    return true;
                }
                else {
                    return false;
                }
            }
            else {
                if (this.user.user_id === createdBy) {
                    return true;
                }
                else {
                    return false;
                }
            }
        }
    }

    disableFuncSales(agencyUsers: any, createdBy: any): any {
        if (this.user.user_role === 'agency_manager' || this.user.user_role === 'agent') {
            if (_.includes(agencyUsers, createdBy)) {
                return true;
            }
            else {
                return false;
            }
        } else {
            return true;
        }
    }

    activityDisableFuntion(createdBy: any, agency: any, assignee: any): any {
        if (this.user.user_role === 'admin' || this.user.user_role === 'agency_admin' || this.user.user_role === 'agency_manager') {
            if (this.user.user_agency === agency) { return true; }
            else { return false; }
        } else {
            if (this.user.user_id === createdBy || this.user.user_id === assignee) { return true; }
            else { return false; }
        }
    }

    addEditDisableFunc(agency: any): boolean {
        if (this.user.user_role === 'admin') {
            return true;
        } else if (agency === this.agency._id) {
            return true;
        } else {
            return false;
        }

    }

    dateFromChanges(dateFrom: any, dateTo: any): void {
        const dateUntil = moment(dateFrom.value).add(7, 'days');
        if (moment(dateTo.value) < moment(dateFrom.value)) {
            dateTo.setValue(dateUntil);
        }
        if (!dateTo.value) {
            dateTo.setValue(dateUntil);
        }
    }

    dateToChanges(dateFrom: any, dateTo: any): void {
        if (moment(dateTo.value) < moment(dateFrom.value)) {
            dateTo.setValue(moment(dateFrom.value));
        }
    }

    datePatch(formControl: any, dateFrom: any): void {
        formControl.setValue(moment(dateFrom * 1000).format());
    }

    onCallMobile(data: any, callNumber?: any): void {
        const message = {
            message: 'Outgoing call',
            activity_type: data.activity_type,
            related_to: 'Property',
            related_to_id: '',
            comment: 'Outgoing call',
            created_by: this.user.user_id,
            model: data.model,
            model_id: data._id,
            user: this.user.full_name,
            user_id: this.user.user_id,
        };

        this._timeLineService.addComment(this.cleanObject(message))
            .subscribe(() => {
                window.location.href = 'tel:' + callNumber;
            });
    }

    accessAccountData(account: any): boolean {
        const assignedTo = _.isArray(account.assigned_to) ? account.assigned_to : [];
        const isAgent = this.user.user_role === 'agent' || this.user.user_role === 'agent_medium' || this.user.user_role === 'admin_agent_light';
        //const hasAccess = this.agency.agent_access;
        const accesToAccount = account.created_by === this.user.user_id || _.indexOf(assignedTo, this.user.user_name) > -1;
        if (isAgent) {
            return accesToAccount;
        } else {
            return true;
        }
    }
    accessOwnerData(owner: any): boolean {
        const assignedTo = _.isArray(owner.assign_agent) ? owner.assign_agent : [];
        const isAgent = this.user.user_role === 'agent' || this.user.user_role === 'agent_medium' || this.user.user_role === 'admin_agent_light';
        // const hasAccess = !this.agency.agent_access_owner;
        const accesToOwner = owner.created_by === this.user.user_id || _.indexOf(assignedTo, this.user.user_id) > -1;
        if (isAgent) {
            return accesToOwner;
        } else {
            return true;
        }
    }

    setPaginator(user): any {
        const pagenator = {} as any;
        pagenator.pageSizeOptions = this.paginatorSizes();
        pagenator.pageSize = 30;
        return pagenator;
    }

    paginatorSizes(): any {
        return [30, 35, 40, 45, 50];
    }

    getUserRole(role: any): boolean {
        if (role === 'admin_agent_light' || role === 'agent') {
            return true;
        } else {
            return false;
        }
    }
    sortRegardingLanguage(dataset, fieldName, language, direction?): any {

        direction = direction ? direction : 'asc';
        return _.orderBy(dataset, (o) => { return o[fieldName][language] }, direction);

    }

    getDays(day: any): any {
        switch (day) {
            case 1: {
                return this._translateService.instant('Sun');
                break;
            }
            case 2: {
                return this._translateService.instant('Mon');
                break;
            }
            case 3: {
                return this._translateService.instant('Tue');
                break;
            }
            case 4: {
                return this._translateService.instant('Wed');
                break;
            }
            case 5: {
                return this._translateService.instant('Thu');
                break;
            }
            case 6: {
                return this._translateService.instant('Fri');
                break;
            }
            case 0: {
                return this._translateService.instant('Sat');
                break;
            }
            default: {
                return null;
                break;
            }
        }
    }

    getMonths(month: any): any {
        switch (month) {
            case 1: {
                return this._translateService.instant('JAN');
                break;
            }
            case 2: {
                return this._translateService.instant('FEB');
                break;
            }
            case 3: {
                return this._translateService.instant('MAR');
                break;
            }
            case 4: {
                return this._translateService.instant('APR');
                break;
            }
            case 5: {
                return this._translateService.instant('MAY');
                break;
            }
            case 6: {
                return this._translateService.instant('JUN');
                break;
            }
            case 7: {
                return this._translateService.instant('JUL');
                break;
            }
            case 8: {
                return this._translateService.instant('AUG');
                break;
            }
            case 9: {
                return this._translateService.instant('SEP');
                break;
            }
            case 10: {
                return this._translateService.instant('OCT');
                break;
            }
            case 11: {
                return this._translateService.instant('NOV');
                break;
            }
            case 12: {
                return this._translateService.instant('DEC');
                break;
            }
            default: {
                return null;
                break;
            }
        }
    }
    agentAccess(): boolean {
        const isAgent = this.user?.user_role === 'agent' || this.user?.user_role === 'agent_medium' || this.user?.user_role === 'admin_agent_light';
        if (isAgent) {
            return false;
        } else {
            return true;
        }
    }
    // Determines if the current user is auditor or not?
    isAuditor(): boolean {
        return ['admin_auditor', 'user_auditor'].includes(this.user?.user_role);
    }
    /**
     * Checks if the current user has one of the allowed roles.
     *
     * @param allowedRoles - A single role (string) or an array of roles.
     * @returns true if the current user's role matches one of the allowed roles, false otherwise.
     */
    userHasRole(allowedRoles: string[] | string): boolean {
        const roles = Array.isArray(allowedRoles) ? allowedRoles : [allowedRoles];
        return roles.includes(this.user?.user_role);
    }

    /**
     * Opens a snack bar at the bottom of the screen.
     * 
     * @param message The message to be displayed in the snack bar.
     * @param action The action label (e.g., "Close") to be displayed in the snack bar.
     */
    openSnackBar(message: string, action: string) {
        this._snackBar.open(message, action, {
            duration: 3000,
        });
    }

    /**
     * capitalize first letter of provided string
     */
    capitalizeFirstLetter(str: string) {
        // Handle empty or non-string inputs gracefully
        if (typeof str !== 'string' || str.length === 0) {
            return str;
        }
        return str.charAt(0).toUpperCase() + str.slice(1);
    }
    /**
     * Format phone number (country code + number)
     * @param country_code string
     * @param phone_number string
     * @returns formatted phone Number
     */

    formatPhoneNumber(country_code: string, phone_number: string): string {
        if (!country_code || !phone_number) return '';

        const digitsOnly = String(phone_number).replace(/\D/g, '');
        const grouped = this.groupDigits(digitsOnly);
        const completeNumber = `${country_code} ${grouped}`.trim();

        return completeNumber.startsWith('+') ? completeNumber : `+${completeNumber}`;
    }

    /**
     * Group digits in sets of 3, except the last group which can be up to 4 digits max.
     * @param digits string
     * @returns grouped digits
     */

    groupDigits(digits: string): string {
        if (digits.length <= 3) return digits;

        let groups = '';
        let i = 0;

        while (i < digits.length) {
            const remaining = digits.length - i;
            let groupSize = 3;

            if (remaining <= 4 && remaining !== 3) {
                groupSize = remaining;
            }

            groups += digits.substring(i, i + groupSize);
            i += groupSize;

            if (i < digits.length) {
                groups += ' ';
            }
        }

        return groups;
    }

    // "the_string_value" => "The string value"
    formatAndCapitalizeString(string?: string | null): string {
        if (!string) return '';
        const replaced = string.replace(/_/g, ' ');
        return replaced.charAt(0).toUpperCase() + replaced.slice(1);
    }

    /**
     * Sorts an array of objects by the translated value of a given field.
     *
     * @param items   The original array (API response).
     * @param field   The field whose translated value should be used for sorting.
     */
    sortByTranslatedField(
        items: any[],
        field: string,
        options?: {
            includeTranslated?: boolean;
            translatedKey?: string;
            order?: 'asc' | 'desc';
        }
    ): any[] {
        if (!items?.length) return items;

        if (!(field in items[0])) return items;

        const {
            includeTranslated = false,
            translatedKey = `${field}_translated`,
            order = 'asc'
        } = options || {};

        return [...items]
            .map(item => {
                const original = item[field];

                const safeOriginal = (original !== undefined && original !== null)
                    ? String(original)
                    : '';

                const translated = this._translateService.instant(safeOriginal);

                return includeTranslated
                    ? {
                        ...item,
                        [translatedKey]: translated
                    }
                    : {
                        ...item,
                        __translatedSortKey: translated
                    };
            })
            .sort((a, b) => {
                const keyA = includeTranslated ? a[translatedKey] : a.__translatedSortKey;
                const keyB = includeTranslated ? b[translatedKey] : b.__translatedSortKey;

                return order === 'asc'
                    ? keyA.localeCompare(keyB)
                    : keyB.localeCompare(keyA);
            })
            .map(item => {
                if (includeTranslated) return item;

                // remove temp key if not needed
                const { __translatedSortKey, ...rest } = item;
                return rest;
            });
    }

    /**
     * Draft a message that shows how long a process (queue, ..) is expected to take
     * @param time number
     * @returns string
     */
    getProcessTimeMessage(time: number, message?: string): string {
        message = message || 'Process will be completed within almost';
        message = this._translateService.instant(message);

        if (time < 60) {
            return message + ` ${time} ` + this._translateService.instant('seconds.');
        }
        else return message + ` ${(time / 60).toFixed(2)} ` + this._translateService.instant('minute/s.');
    }

    /**
     * Displays translated validation error messages for invalid fields in a given FormGroup.
     *
     * This function identifies invalid fields, marks them as touched, translates their labels (if available),
     * and shows a single summarized error message.
     *
     * @param formGroup - The reactive form group to validate.
     * @param fieldKeys - Optional mapping of form field names to translation keys (defaults to field name if not provided).
     * @param shouldFieldBeValidated - Optional callback to conditionally include/exclude fields from validation.
     */
    showValidationErrors(
        formGroup: FormGroup,
        fieldKeys?: { [key: string]: string },
        shouldFieldBeValidated?: (field: string) => boolean
    ): void {
        const invalidFields: string[] = [];

        Object.keys(formGroup.controls).forEach((field) => {
            const control = formGroup.get(field);

            if (control?.invalid && control?.errors) {
                // Check validation condition only if function is provided
                if (!shouldFieldBeValidated || shouldFieldBeValidated(field)) {
                    control.markAsTouched();

                    // Use mapping if available, otherwise use field name itself
                    const fieldKey = fieldKeys?.[field] || field;
                    const translatedLabel = this._translateService.instant(fieldKey);

                    invalidFields.push(translatedLabel);
                }
            }
        });

        if (invalidFields.length > 0) {
            const message = invalidFields.join(', ');
            this._baseService.errorMessage(message, 'Please fill in required fields');
        }
    }

    /**
     * Dynamically creates and populates form fields within a given FormArray.
     *
     * This utility function clears the specified FormArray and repopulates it
     * based on the provided data. For each entry in the data object, it clones
     * the given FormGroup template (`formGroupObj`), pushes it into the FormArray,
     * and patches the corresponding values into the parent FormGroup.
     *
     * If no data is provided, or the data is empty, it ensures at least one
     * default FormGroup instance is added to the FormArray.
     *
     * @param formArrayName - The FormArray where new form groups will be added.
     * @param fieldName - The key name representing the field in the parent form group.
     * @param data - The data used to populate form fields; each entry creates one FormGroup.
     * @param formGroupObj - A FormGroup template used to generate new form entries.
     * @param parentFormGroup - The parent FormGroup that contains the FormArray and its fields.
     */
    createFormFields(
        formArrayName: FormArray,
        fieldName: any,
        data: any,
        formGroupObj: FormGroup,
        parentFormGroup: FormGroup
    ): void {
        this.clearFormArray(formArrayName);
        if (data) {
            _.forEach(data, (value, key) => {
                const newObj = _.cloneDeep(formGroupObj);
                formArrayName.push(newObj);
                parentFormGroup.get(fieldName + '.' + key).patchValue(value);
            });
        } else {
            formArrayName.push(formGroupObj);
        }
        if (formArrayName.length === 0) {
            formArrayName.push(formGroupObj);
        }
    }

    clearFormArray = (formArray: FormArray) => {
        while (formArray.length !== 0) {
            formArray.removeAt(0);
        }
    };
    /**
     * Confirm password validator
     *
     * @param {AbstractControl} control
     * @returns {ValidationErrors | null}
     */
    MustMatch(
        controlName: string,
        matchingControlName: string
    ): any {
        return (formGroup: FormGroup) => {
            const control = formGroup.controls[controlName];
            const matchingControl = formGroup.controls[matchingControlName];

            if (matchingControl.errors && !matchingControl.errors.mustMatch) {
                // return if another validator has already found an error on the matchingControl
                return;
            }

            // set error on matchingControl if validation fails
            if (control.value !== matchingControl.value) {
                matchingControl.setErrors({ mustMatch: true });
            } else {
                matchingControl.setErrors(null);
            }
        };
    }
    /**
     * Terms password validator
     *
     * @param {AbstractControl} control
     * @returns {ValidationErrors | null}
     */
    termsValidator: ValidatorFn = (
        control: AbstractControl
    ): ValidationErrors | null => {
        if (!control.parent || !control) {
            return null;
        }

        const terms = control.parent.get('terms');

        if (!terms) {
            return null;
        }

        if (terms.value) {
            return null;
        }

        return { termsNotAccept: true };
    };

    /**
     * Convert RGB/RGBA color to hex format
     */
    rgbToHex(rgb: string): string {
        // Match rgb(r, g, b) or rgba(r, g, b, a)
        const match = rgb.match(/^rgba?\((\d+),\s*(\d+),\s*(\d+)(?:,\s*(\d+(?:\.\d+)?))?\)$/);

        if (!match) {
            return rgb; // Return as-is if not in rgb format
        }

        const r = parseInt(match[1]);
        const g = parseInt(match[2]);
        const b = parseInt(match[3]);
        const a = match[4] ? parseFloat(match[4]) : 1;

        // Convert to hex
        const toHex = (n: number) => {
            const hex = n.toString(16);
            return hex.length === 1 ? '0' + hex : hex;
        };

        const alphaHex = a < 1 ? toHex(Math.round(a * 255)) : 'ff';

        return `#${toHex(r)}${toHex(g)}${toHex(b)}${alphaHex}`;
    }

    /**
     * Copies a text value into all language controls of a FormGroup
     *
     * @param form        Parent FormGroup
     * @param controlKey  Key of the multilingual FormGroup (e.g. 'value')
     * @param text        Text to copy
     * @param languages   List of language objects with `id`
     */
    copyTextToAllLanguages(form: FormGroup, controlKey: string, text: string) {
        const group = form.get(controlKey) as FormGroup;
        if (!group) {
            return;
        }
        const patch: Record<string, string> = {};
        this._app.siteLanguages.forEach(lang => {
            if (group.get(lang.id)) {
                patch[lang.id] = text;
            }
        });
        group.patchValue(patch, { emitEvent: false });
    }

    /**
     * Validate if a string is a valid MongoDB ObjectId
     * @param id The string to validate
     * @returns True if the string is a valid MongoDB ObjectId, false otherwise
     */
    isValidMongoId(id: string): boolean {
        const regex = /^[a-f\d]{24}$/i;
        return regex.test(id);
    }

    /**
     * Calculate the expiry date based on the selected document type and agency country
     * @param key The key of the selected document type
     * @param documentsTypes The list of document types
     * @param form The form group containing the expiry date field
     */
    calculateExpiryDate(key: number, documentsTypes: any[], form: FormGroup): void {
        const selectedType = documentsTypes.find((t) => t.key === key);
        if (!selectedType) return;

        const countryId = this.agency?.complete_address_country;

        if (!countryId) return;

        const countryPolicy = (
            selectedType.deletion_policy_per_country || []
        ).find((p) => p.country == countryId);

        let expiryDate: Date = null;
        const now = new Date();

        if (countryPolicy) {
            const numberOfYears = countryPolicy.number_of_years;
            const policy = countryPolicy.deletion_policy;

            if (numberOfYears && !isNaN(parseInt(numberOfYears))) {
                const years = parseInt(numberOfYears);
                now.setFullYear(now.getFullYear() + years);
                expiryDate = now;
            } else if (policy) {
                switch (policy) {
                    case 'never':
                        expiryDate = new Date(9999, 11, 31);
                        break;
                    case 'five_years':
                        now.setFullYear(now.getFullYear() + 5);
                        expiryDate = now;
                        break;
                    case 'ten_years':
                        now.setFullYear(now.getFullYear() + 10);
                        expiryDate = now;
                        break;
                    case 'normal':
                    default:
                        expiryDate = null;
                        break;
                }
            }
        }

        form.get('expiration_date').setValue(expiryDate);
    }

    /**
     * Set default document language for attachments and queue items
     * based on user's default language
     * @param systemLanguages List of available system languages
     * @param form The form group containing the language field
     */
    setDefaultDocLanguage(systemLanguages: any[], form: FormGroup): void {
        const currentValue = form.get('language')?.value;

        // Only set default if language field is empty or not yet set
        if (!currentValue || currentValue.length === 0) {
            const userLangKey = this.user?.default_lang
                ?.split('_')[0]
                ?.toUpperCase(); // e.g., 'es_AR' -> 'ES'

            if (systemLanguages.some((lang) => lang.key === userLangKey)) {
                form.get('language')?.setValue([userLangKey]);
            }
        }
    }
    /**
     * Fetch document counts for a list of records and update each record with 'documents' count
     * @param records Array of records to update
     * @param modelName Name of the model in attachments collection
     * @param idField The field name in records that holds the ID (default: '_id')
     */
    getAttachmentsCount(records: any[], modelName: string, idField: string = '_id'): Observable<any> {
        if (!records || records.length === 0) return of(null);

        const ids = records.map(r => r[idField]).filter(id => !!id);
        if (ids.length === 0) return of(null);

        const payload = {
            query: {
                model_id: { $in: ids },
                model_name: modelName
            },
            options: {
                limit: 1000,
                select: 'model_id'
            }
        };

        return this._baseService.post('attachments/get-attachments', payload, 'nodejs').pipe(
            map(response => {
                if (response.success) {
                    const attachments = response.data.docs;
                    records.forEach(record => {
                        const id = record[idField];
                        record.documents = attachments.filter(a => a.model_id === id).length;
                    });
                }
                return records;
            })
        );
    }
}
